import {useMutation, useQueryClient} from "@tanstack/react-query";

import {errorHandler} from "@/src/modules/core/lib";

import {shiftsService} from "../services";
import type {AddPatrolVisitRequest} from "../types";

export function useAddPatrolVisit() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({shiftId, data}: {shiftId: number; data: AddPatrolVisitRequest}) =>
      shiftsService.addPatrolVisit(shiftId, data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ["active-shift"]});
    },
    onError: errorHandler,
  });
}
